export const getNestedPropertyValue = (obj, path) => {
  const keys = path.split('.');
  return keys.reduce(
    (value, key) => (value !== undefined ? value[key] : undefined),
    obj,
  );
};

const trimLeadingSpaces = str => (typeof str === 'string' ? str.trim() : str);

/**
   *
   * @param {Array<any>} array Unsorted Array elements
   * @param {string} sortBy Paramter via which it needs to be sorted, Can give nested reference
   * @param {*} sortOrder 'ascending' | 'descending' sortorder
   * @returns
   */
export const sortArrayByProperty = (array, sortBy, sortOrder = 'ascending') => {
  if (sortBy == null || sortBy === undefined) {
    return array;
  }

  return array.sort((a, b) => {
    const valueA = trimLeadingSpaces(getNestedPropertyValue(a, sortBy));
    const valueB = trimLeadingSpaces(getNestedPropertyValue(b, sortBy));

    // Handle equal casing
    if (valueA === valueB) {
      return 0;
    }

    // Determine the sort order
    const compareResult = sortOrder === 'descending' ? -1 : 1;

    return valueA < valueB ? -compareResult : compareResult;
  });
};
